<div class="container">
  <!-- project title -->
  <div class="py-3">
    <div class="font-weight-bold" style="font-size: 20px" appHighlightKeyword>{{ project?.Title }}</div>
  </div>

  <app-project-tabs *ngIf="project" [project]="project"></app-project-tabs>
</div>
